const pagesData = require('@/pages.json');
export const IS_DEV = process.env.NODE_ENV === 'development';
export const IS_APP = uni.getSystemInfoSync().uniPlatform === 'app';
export const PAGES = pagesData.default.pages || [];

// 线上环境域名
export const PROD_URLS = [
  'm.ceekee.com',
  'd.ceekee.com',
  'distribution.ceekee.com',
  'sweixin.ceekee.com',
  'dingding.ceekee.com',
  'feishu.ceekee.com',
  'newmaiwei.ceekee.com',
  'mtrip.gdcts.com',
];

// 测试应用上报地址
export const TEST_REPORT_URL = IS_DEV
  ? 'http://chailvguanjia.datasink.sensorsdata.cn/sa?project=default&token=1c3d7174a0759950'
  : 'https://chailvguanjia.datasink.sensorsdata.cn/sa?project=default&token=1c3d7174a0759950';
// 正式应用上报地址
export const PROD_REPORT_URL =
  'https://chailvguanjia.datasink.sensorsdata.cn/sa?project=production&token=1c3d7174a0759950';
